import axios from 'axios';

export const getApiErrorMessage = (error: unknown, fallback: string) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: string };
    if (data?.message && typeof data.message === 'string') {
      return data.message;
    }
  }

  if (error instanceof Error && typeof error.message === 'string') {
    return error.message;
  }

  return fallback;
};

// Admin-rutterna svarar { error: 'kod', details?: 'text' } där de äldre svarar { message }.
// Koden säger vad som gick fel och details varför — därför båda, i den ordningen.
export const getApiErrorDetails = (error: unknown, fallback = 'Okänt fel'): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { error?: unknown; details?: unknown } | undefined;
    if (typeof data?.error === 'string') {
      // details är ett zod-flatten-objekt vid 400 — det får aldrig nå JSX som [object Object].
      return typeof data.details === 'string' ? `${data.error}: ${data.details}` : data.error;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
};
